import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class KycProfileService {
  constructor(private http: HttpClientService) {}

  public post(kyc_profile): Observable<any> {
    return this.http
      .post("/api/kyc_profiles", kyc_profile)
      .pipe(tap((_) => console.log("KycProfileService.post: Ok.")));
  }

  public updateKycProfile(id, data): Observable<any> {
    return this.http
      .put(`/api/kyc_profiles/${id}`, data)
      .pipe(tap((_) => console.log("KycProfileService.update: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http.delete(`/api/kyc_profiles/${id}`).pipe(tap((_) => console.log("KycProfileService.delete: Ok.")));
  }

  public getPdf(id: string | number): Observable<Blob> {
    return this.http
      .get(`/api/kyc_profiles/${id}/pdf`, { responseType: "blob" as "json" })
      .pipe(tap((_) => console.log("KycProfileService.getPdf: Ok.")));
  }

  public sendForSignature(id: string | number, body: any = {}): Observable<any> {
    return this.http
      .post(`/api/kyc_profiles/${id}/send_for_signature`, body)
      .pipe(tap((_) => console.log("KycProfileService.sendForSignature: Ok.")));
  }
}
